import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wave-top',
  templateUrl: './wave-top.component.html'
})
export class WaveTopComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
